const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  language: state => state.app.language,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  size: state => state.app.size,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  resouces: state => state.user.resouces,
  appId: state => state.appflow.appId,
  hisList: state => state.appflow.hisList,
  appInfo: state => state.appflow.appInfo
}
export default getters
